export enum MyAccountPages {
  Home = 'home',
  Profile = 'profile',
  Billing = 'billing',
  Subscriptions = 'subscriptions',
  Newsletters = 'newsletters',
}

export const MyAccountPageTitles = {
  [MyAccountPages.Profile]: 'My profile',
  [MyAccountPages.Billing]: 'Billing',
  [MyAccountPages.Subscriptions]: 'Subscription overview',
  [MyAccountPages.Newsletters]: 'Newsletters',
};
